import { render, staticRenderFns } from "./Budgets.vue?vue&type=template&id=60f2bfad&"
import script from "./Budgets.vue?vue&type=script&lang=ts&"
export * from "./Budgets.vue?vue&type=script&lang=ts&"
import style0 from "./Budgets.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports